"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDataToTable = void 0;
var _tsUtils = require("@ori/ts-utils");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const mapDataToTable = table => {
  const {
    columnDefinitions,
    rows
  } = table;
  if (!(0, _tsUtils.isNonNullable)(rows) || !(0, _tsUtils.isNonNullable)(columnDefinitions)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = columnDefinitions.filter(col => (0, _tsUtils.isNonNullable)(col)).map(col => ({
    accessorKey: col.key ?? '',
    header: col.label ?? '',
    Cell: ({
      row
    }) => {
      const {
        key
      } = col;
      if (!key) {
        return '–';
      }
      const value = row[key];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Html, {
        isOverflowVisible: false,
        maxLines: _constants.CELL_MAX_LINES,
        html: value != null ? String(value) : '-'
      });
    }
  }));
  const data = rows.filter(_tsUtils.isNonNullable).map(row => {
    const record = {};
    row.cells?.forEach(cell => {
      if ((0, _tsUtils.isNonNullable)(cell) && cell.columnKey) {
        record[cell.columnKey] = (0, _utils.transformHtmlContent)(cell.value);
      }
    });
    return record;
  });
  return {
    columns,
    data
  };
};
exports.mapDataToTable = mapDataToTable;
